import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const EmailLoginIcon = ({ color = Color.White, className }: NewIconProps) => (
  <svg
    className={twMerge('size-[16px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g id="Communication/email">
      <path
        id="ð¨ Icon Style"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 5C2.89543 5 2 5.89543 2 7V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V7C22 5.89543 21.1046 5 20 5H4ZM11.999 14L4.00042 9.00026L4 9.00042V11L10.9389 15.3374C11.5875 15.7428 12.4105 15.7428 13.0591 15.3374L19.9979 11V9.00042L19.9975 9.00026L11.999 14Z"
        fill={color}
      />
    </g>
  </svg>
);
